;(function() {
  'use strict'

  Factory.$inject = ["$filter"];
  angular.module('app.core').factory('quotaTextService', Factory)

  /* @ngInject */
  function Factory($filter) {
    var numberFilter = $filter('number')

    return {
      pluralise: pluralise,
      formatProgress: formatProgress,
    }

    function pluralise(count, singular, plural) {
      return (
        Number(count).toLocaleString() + ' ' + (count === 1 ? singular : plural)
      )
    }

    // the achieved count bound to its target in one phrase, so a lone number can never be read as a status; split so the count can be set bold and the rest light
    // the leading space is the only ordinary one in rest, so a label too wide for its line wraps there and never inside a number
    function formatProgress(achieved, target, hasBlank) {
      achieved = _.isNumber(achieved) ? achieved : 0

      if (!_.isNumber(target)) {
        return { count: numberFilter(achieved), rest: ' of\u00a0no\u00a0limit' }
      }

      var suffix = hasBlank ? '+' : ''

      if (target === 0 && !hasBlank) {
        return achieved > 0
          ? { count: numberFilter(achieved), rest: ' ·\u00a0Closed' }
          : { count: '', rest: 'Closed' }
      }

      return {
        count: numberFilter(achieved),
        rest: ' of\u00a0' + numberFilter(target) + suffix,
      }
    }
  }
})()
